<li class="nav-item">
  <a class="nav-link spk-tab" [ngClass]="class" id="{{name}}" data-toggle="tab" href="#{{name}}" role="tab" (click)="updateTab(name)"
    attr.aria-controls="{{name}}">{{label || (name | stringSpacer)}}</a>
</li>